/* Shop-the-guide articles: sticky product bar + CTA click tracking.
   Markup: sections/main-article-shop.liquid */
(function () {
  var DISMISS_KEY = 'articleShopStickyDismissed';

  function isDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }

  function setDismissed() {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }

  // Clarity custom events + a Shopify customer event, so clicks can be split by placement.
  function track(name, data) {
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('gto_' + name, data);
      }
    } catch (e) {}
  }

  function bindTracking(el, article) {
    el.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-article-shop-cta]');
      if (!cta) return;
      var card = cta.closest('[data-handle]');
      var placement = cta.getAttribute('data-article-shop-cta');
      track('blog_cta_' + placement.split('-')[0], {
        placement: placement,
        product: card ? card.getAttribute('data-handle') : cta.getAttribute('data-handle') || null,
        article: article
      });
    });
  }

  function init(root) {
    if (root.hasAttribute('data-article-shop-ready')) return;
    root.setAttribute('data-article-shop-ready', '');

    var article = root.getAttribute('data-article');
    var sectionId = root.getAttribute('data-section-id');
    try { if (window.clarity) window.clarity('set', 'blog_template', 'shop-the-guide'); } catch (e) {}
    bindTracking(root, article);

    var template = root.querySelector('template[data-article-shop-sticky-template]');
    var json = root.querySelector('[data-article-shop-products]');
    var cards = root.querySelectorAll('.article-shop-card--inline');
    if (!template || !json || !cards.length) return;

    var products;
    try { products = JSON.parse(json.textContent); } catch (e) { return; }

    document.querySelectorAll('[data-article-shop-sticky][data-section-id="' + sectionId + '"]').forEach(function (n) { n.remove(); });
    var bar = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(bar);
    bindTracking(bar, article);

    var grid = root.querySelector('[data-article-shop-grid]');
    var links = bar.querySelectorAll('a');
    var image = bar.querySelector('.article-shop-sticky__image');
    var title = bar.querySelector('.article-shop-sticky__title');
    var price = bar.querySelector('.article-shop-sticky__price');
    var focusables = bar.querySelectorAll('a, button');
    var currentHandle = null;
    var visible = false;
    var shownOnce = false;
    var ticking = false;

    function setProduct(handle) {
      if (handle === currentHandle) return;
      var p = products[handle];
      if (!p) return;
      currentHandle = handle;
      bar.setAttribute('data-handle', handle);
      links.forEach(function (a) { a.href = p.url; });
      image.src = p.image;
      image.alt = p.title;
      title.textContent = p.title;
      price.textContent = p.price;
    }

    function setVisible(show) {
      if (show === visible) return;
      visible = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      focusables.forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      if (show && !shownOnce) {
        shownOnce = true;
        track('blog_sticky_shown', { product: currentHandle, article: article });
      }
    }

    // Follow the last card scrolled past; hide while any card or the product row is on screen.
    function update() {
      ticking = false;
      if (isDismissed()) return setVisible(false);
      var vh = window.innerHeight;
      var passed = null;
      var cardOnScreen = false;
      cards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        if (r.bottom < 0) passed = card;
        if (r.top < vh && r.bottom > 0) cardOnScreen = true;
      });
      var gridReached = grid && grid.getBoundingClientRect().top < vh;
      if (passed) setProduct(passed.getAttribute('data-handle'));
      setVisible(!!passed && !cardOnScreen && !gridReached);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    bar.querySelector('[data-article-shop-sticky-close]').addEventListener('click', function () {
      setDismissed();
      setVisible(false);
      track('blog_sticky_dismissed', { product: currentHandle, article: article });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-article-shop]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-article-shop]');
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    document.querySelectorAll('[data-article-shop-sticky][data-section-id="' + event.detail.sectionId + '"]').forEach(function (n) { n.remove(); });
  });
})();
